import { useEffect, useState } from 'react';
import axios from 'axios';
import { BACKEND_URL } from '../../utils/backendURL';

export default function useQualityOverview(includeHistory = false) {
  const [days, setDays] = useState(7);
  const [project, setProject] = useState('');
  const [type, setType] = useState('all');
  const [projects, setProjects] = useState([]);
  const [revision, setRevision] = useState(0);
  const [state, setState] = useState({ data: null, loading: true, error: false });
  useEffect(() => {
    const controller = new AbortController();
    setState({ data: null, loading: true, error: false });
    axios
      .get(`${BACKEND_URL}/api/dashboard/quality-overview`, {
        params: {
          include_history: includeHistory,
          days,
          test_type: type,
          ...(project ? { project_id: project } : {}),
        },
        signal: controller.signal,
      })
      .then(({ data }) => {
        if (!controller.signal.aborted) {
          setProjects(data.projects);
          setState({ data, loading: false, error: false });
        }
      })
      .catch(() => {
        if (!controller.signal.aborted) setState({ data: null, loading: false, error: true });
      });
    return () => controller.abort();
  }, [days, project, type, revision, includeHistory]);
  return {
    ...state,
    projects,
    days,
    setDays,
    project,
    setProject,
    type,
    setType,
    refresh: () => setRevision((current) => current + 1),
  };
}
